import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  MATCH_STATUS,
  STATUS_KEYS,
  StatusKey,
} from '../../constants/cash-reconciliation.constants';

@Component({
  selector: 'app-cash-reconciliation-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent {
  @Input() status: StatusKey | '--' = STATUS_KEYS.PENDING;
  @Input() delta: number | null = null;
  @Input() showStatus = true;

  get isPlain(): boolean {
    return this.status === '--';
  }

  get cfg() {
    return this.isPlain
      ? {
          bg: 'transparent',
          text: '#6B7280',
          label: '--',
        }
      : (MATCH_STATUS[this.status as StatusKey] ?? MATCH_STATUS[STATUS_KEYS.PENDING]);
  }

  // Single source for showing --
  get showPlain(): boolean {
    return this.isPlain || this.status === STATUS_KEYS.PENDING;
  }

  get shouldShowDelta(): boolean {
    return !this.showPlain && this.delta != null;
  }

  get deltaColor(): string {
    return Number(this.delta) === 0 ? '#16A34A' : '#EF4444';
  }

  get formattedDelta(): string {
    const delta = Number(this.delta ?? 0);

    return delta < 0 ? `-$${Math.abs(delta).toFixed(2)}` : `$${delta.toFixed(2)}`;
  }
}
